const STORAGE_KEY = 'plaid:link';
const MAX_AGE_MS = 60 * 60 * 1000;

interface PlaidOAuthSession {
  token: string;
  returnPath: string;
  ts: number;
}

const usePlaidOAuth = () => {
  const persistPlaidSession = (token: string, returnPath: string): void => {
    if (typeof window === 'undefined' || !token) return;
    const payload: PlaidOAuthSession = { token, returnPath, ts: Date.now() };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  };

  const readPlaidSession = (): PlaidOAuthSession | null => {
    if (typeof window === 'undefined') return null;
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw) as PlaidOAuthSession;
      if (!parsed?.token || Date.now() - parsed.ts > MAX_AGE_MS) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed;
    } catch {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  };

  const clearPlaidSession = (): void => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(STORAGE_KEY);
  };

  const isOAuthResume = (): boolean => {
    if (typeof window === 'undefined') return false;
    return window.location.search.includes('oauth_state_id=');
  };

  return { persistPlaidSession, readPlaidSession, clearPlaidSession, isOAuthResume };
};

export default usePlaidOAuth;
